/**
 * useBulkVotes — fetch aggregate stats and current-visitor votes in
 * two grouped requests (down from 2 × N).
 *
 * Callers frequently pass a fresh derived array (e.g. `arr.slice(0, N)`)
 * that changes identity on every render, so we depend on the derived ids
 * string (a primitive) — NOT the items array — to avoid an infinite
 * refetch loop.
 */
import { useEffect, useState } from "react";
import { api, releaseId } from "../lib/api";

export function useBulkVotes(items) {
  const [statsById, setStatsById] = useState({});
  const [mineById, setMineById] = useState({});

  const idsParam =
    !items || items.length === 0 ? "" : items.map(releaseId).join(",");

  useEffect(() => {
    if (!idsParam) {
      setStatsById({});
      setMineById({});
      return;
    }
    let alive = true;
    Promise.all([
      api.get("/votes", { params: { ids: idsParam } }),
      api.get("/votes/mine/bulk", { params: { ids: idsParam } }),
    ])
      .then(([s, m]) => {
        if (!alive) return;
        setStatsById(s.data || {});
        setMineById(m.data || {});
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [idsParam]);

  return { statsById, mineById };
}
